import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiHome, FiArrowLeft, FiSearch, FiAlertCircle } from 'react-icons/fi';
import Button from '../../components/common/Button';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-illustration">
          <div className="error-code">404</div>
          <FiAlertCircle className="error-icon" size={64} />
        </div>
        
        <div className="error-content">
          <h1 className="error-title">Page Not Found</h1>
          <p className="error-description">
            Sorry, we couldn't find the page you're looking for. 
            The page might have been moved, deleted, or you entered the wrong URL.
          </p>
          
          <div className="error-suggestions">
            <h3>What you can do:</h3>
            <ul>
              <li>Check the URL for any typos</li>
              <li>Go back to the previous page</li>
              <li>Visit our homepage</li>
              <li>Use the search function to find what you're looking for</li>
            </ul>
          </div>
          
          <div className="error-actions">
            <Button 
              variant="outline" 
              onClick={handleGoBack}
              className="action-button"
            >
              <FiArrowLeft size={16} />
              Go Back
            </Button>
            
            <Button 
              variant="primary" 
              onClick={handleGoHome}
              className="action-button"
            >
              <FiHome size={16} />
              Go Home
            </Button>
            
            <Link to="/search" className="text-link">
              <FiSearch size={16} />
              Search Site
            </Link>
          </div>
        </div>
        
        <div className="error-footer">
          <p>Need help? <Link to="/contact">Contact Support</Link></p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;